import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Spinner } from "reactstrap";
import SimpleBar from "simplebar-react";

// i18n
import { withTranslation } from "react-i18next";

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // OData API'den bildirimleri çekme fonksiyonu
  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const userId = authUser?.ID;
      
      // 📌 YENİ: Token'ı alıyoruz
      const token = localStorage.getItem("token") || authUser?.Token;

      // Token veya Kullanıcı ID yoksa boşuna istek atma
      if (!userId || !token) {
        setIsLoading(false);
        return;
      }

      // Sadece bu kullanıcıya ait son 5 bildirimi çekiyoruz
      // 📌 YENİ: İsteğe headers (Authorization) eklendi
      const response = await fetch(
  `https://harmanagelapi.stechomeyazilim.info/BILDIRIM_LOGLARI?$filter=KULLANICI_ID eq ${userId}&$orderby=ID desc&$top=5`,
  {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  }
);

      if (!response.ok) {
        console.error("Bildirim API Hatası:", await response.text());
        setIsLoading(false);
        return;
      }

      const result = await response.json();

      if (result && result.value) {
        setNotifications(result.value);
      }
    } catch (error) {
      console.error("Bildirimler çekilemedi:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Bileşen yüklendiğinde bildirimleri getir
  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          {notifications.length > 0 && (
            <span className="badge bg-danger rounded-pill">
              {notifications.length}
            </span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 font-size-16"> {props.t("Bildirimler")} </h6>
              </Col>
              <div className="col-auto">
                <Link to="#!" className="small" onClick={(e) => { e.preventDefault(); fetchNotifications(); }}>
                  <i className="mdi mdi-refresh me-1"></i> Yenile
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {isLoading ? (
              <div className="text-center py-4">
                <Spinner size="sm" color="primary" />
              </div>
            ) : notifications.length > 0 ? (
              notifications.map((item, index) => (
                <Link to="" className="text-reset notification-item" key={index}>
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <i className="bx bx-info-circle" />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">{item.Notifications_Title}</h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">{item.Notifications_Desc}</p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {item.OLUSTURMA_TARIHI 
                            ? new Date(item.OLUSTURMA_TARIHI).toLocaleString("tr-TR") 
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <div className="text-center py-5 text-muted">
                <p className="mb-0">Henüz bir bildiriminiz yok.</p>
              </div>
            )}
          </SimpleBar>

          <div className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="#">
              <i className="mdi mdi-arrow-right-circle me-1"></i> {props.t("Tümünü Gör")}..
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

NotificationDropdown.propTypes = {
  t: PropTypes.any
};

export default withTranslation()(NotificationDropdown);